(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function formatTime(ms) {
      if (ms < 0) ms = 0;
      var totalSeconds = Math.floor(ms / 1000);
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    }

    function initCountdown(el) {
      var hours = parseFloat(el.getAttribute('data-countdown-hours')) || 24;
      var varianceHours = parseFloat(el.getAttribute('data-countdown-variance-hours')) || 0;
      var shouldReset = el.getAttribute('data-countdown-reset') === 'true';
      var storageKey = 'tapp_countdown_end_' + el.getAttribute('data-countdown-id');
      var durationMs = hours * 60 * 60 * 1000;
      var varianceMs = varianceHours * 60 * 60 * 1000;
      var intervalId;

      function randomDuration() {
        var jitter = Math.random() * varianceMs;
        return durationMs - jitter;
      }

      function readStoredEndTime() {
        try {
          return window.localStorage.getItem(storageKey);
        } catch (e) {
          return null;
        }
      }

      function writeStoredEndTime(value) {
        try {
          window.localStorage.setItem(storageKey, String(value));
        } catch (e) {
          /* localStorage unavailable (private browsing, etc). Timer still works, just won't persist across reloads. */
        }
      }

      function getEndTime() {
        var now = Date.now();
        var stored = readStoredEndTime();
        if (stored) {
          var endTime = parseInt(stored, 10);
          if (!isNaN(endTime) && endTime > now) {
            return endTime;
          }
        }
        var newEndTime = now + randomDuration();
        writeStoredEndTime(newEndTime);
        return newEndTime;
      }

      var endTime = getEndTime();

      function update() {
        var now = Date.now();
        var remaining = endTime - now;

        if (remaining <= 0) {
          if (shouldReset) {
            endTime = now + randomDuration();
            writeStoredEndTime(endTime);
            remaining = endTime - now;
          } else {
            remaining = 0;
            if (intervalId) {
              clearInterval(intervalId);
            }
          }
        }

        el.textContent = formatTime(remaining);
      }

      update();
      intervalId = setInterval(update, 1000);
    }

    function initAllCountdowns() {
      var timers = document.querySelectorAll('.sale-countdown-timer');
      timers.forEach(initCountdown);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllCountdowns);
    } else {
      initAllCountdowns();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
